(function () {
  'use strict';

  function getNativeContext() {
    var container = document.querySelector('.t4s-main-collection-page[data-ntajax-container][data-ntajax-options]');
    if (!container) return null;
    try {
      var options = JSON.parse(container.getAttribute('data-ntajax-options'));
      return {
        container: container,
        options: options,
        section: document.getElementById('shopify-section-' + options.id),
        facets: document.getElementById('shopify-section-' + options.typeFilters)
      };
    } catch (error) {
      return null;
    }
  }

  function runNativeFilter(url) {
    var context = getNativeContext();
    var links = context && context.facets && context.facets.querySelector('[data-filter-links]');
    if (!links) {
      window.location.href = url;
      return;
    }
    var link = document.createElement('a');
    link.href = url;
    link.hidden = true;
    links.appendChild(link);
    link.click();
    link.remove();
  }

  function runNativeSort(value) {
    var context = getNativeContext();
    if (!context || !context.section) {
      var fallbackUrl = new URL(window.location.href);
      fallbackUrl.searchParams.set('sort_by', value);
      window.location.href = fallbackUrl.toString();
      return;
    }
    var button = document.createElement('button');
    button.type = 'button';
    button.hidden = true;
    button.setAttribute('data-sortby-item', '');
    button.setAttribute('data-value', value);
    context.section.appendChild(button);
    button.click();
    button.remove();
  }

  function getFormUrl(form) {
    var url = new URL(form.action, window.location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    return url.toString();
  }

  function positionDropdown(dropdown) {
    if (window.innerWidth > 767) return;
    var summary = dropdown.querySelector('summary');
    if (!summary) return;
    var rect = summary.getBoundingClientRect();
    var width = Math.min(290, window.innerWidth - 30);
    var left = Math.max(15, Math.min(rect.left, window.innerWidth - width - 15));
    dropdown.style.setProperty('--lf-menu-left', left + 'px');
    dropdown.style.setProperty('--lf-menu-top', rect.bottom + 8 + 'px');
  }

  function formatMoney(value) {
    if (window.T4SThemeSP && T4SThemeSP.Currency && T4SThemeSP.Currency.formatMoney) {
      return T4SThemeSP.Currency.formatMoney(value);
    }
    return (value / 100).toFixed(3) + ' ' + ((window.Shopify && Shopify.currency && Shopify.currency.active) || '');
  }

  function updatePrice(slider, changedInput) {
    var minInput = slider.querySelector('[data-livish-price-min]');
    var maxInput = slider.querySelector('[data-livish-price-max]');
    if (!minInput || !maxInput) return;
    var min = Number(minInput.value);
    var max = Number(maxInput.value);
    if (min > max) {
      if (changedInput === minInput) min = max;
      else max = min;
    }
    minInput.value = min;
    maxInput.value = max;
    var rangeMax = Number(maxInput.max) || 1;
    slider.style.setProperty('--lf-price-min', min / rangeMax * 100 + '%');
    slider.style.setProperty('--lf-price-max', max / rangeMax * 100 + '%');
    var price = slider.closest('[data-livish-price]');
    price.querySelector('[data-livish-price-min-field]').value = (min / 100).toFixed(2);
    price.querySelector('[data-livish-price-max-field]').value = (max / 100).toFixed(2);
    price.querySelector('[data-livish-price-min-label]').textContent = formatMoney(min);
    price.querySelector('[data-livish-price-max-label]').textContent = formatMoney(max);
  }

  function refresh(root) {
    if (root.dataset.livishFilterRefreshing) return;
    root.dataset.livishFilterRefreshing = 'true';
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', root.dataset.sectionId);
    fetch(url.toString(), { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var documentHtml = new DOMParser().parseFromString(html, 'text/html');
        var next = documentHtml.querySelector('[data-livish-filter]');
        if (!next || !root.isConnected) return;
        root.innerHTML = next.innerHTML;
        root.setAttribute('style', next.getAttribute('style') || '');
      })
      .finally(function () { delete root.dataset.livishFilterRefreshing; });
  }

  function observeNativeResults(root) {
    var context = getNativeContext();
    if (!context || !window.MutationObserver) return;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { refresh(root); }, 50);
    }).observe(context.container, { childList: true });
  }

  function init(root) {
    if (!root || root.dataset.livishFilterInit) return;
    root.dataset.livishFilterInit = 'true';

    root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-livish-price-min], [data-livish-price-max]')) return;
      updatePrice(event.target.closest('.t4s-livish-filter__price-slider'), event.target);
    });

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-livish-filter-input]');
      if (!input) return;
      var form = input.closest('[data-livish-filter-form]');
      if (form) runNativeFilter(getFormUrl(form));
    });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-livish-filter-form]');
      if (!form) return;
      event.preventDefault();
      runNativeFilter(getFormUrl(form));
    });

    root.addEventListener('click', function (event) {
      var sort = event.target.closest('[data-livish-sort-value]');
      if (sort) {
        sort.closest('details').removeAttribute('open');
        runNativeSort(sort.dataset.livishSortValue);
        return;
      }
      var clear = event.target.closest('.t4s-livish-filter__clear');
      if (clear) {
        event.preventDefault();
        runNativeFilter(clear.href);
      }
    });

    root.addEventListener('toggle', function (event) {
      if (!event.target.matches('[data-livish-filter-dropdown]') || !event.target.open) return;
      root.querySelectorAll('[data-livish-filter-dropdown][open]').forEach(function (dropdown) {
        if (dropdown !== event.target) dropdown.removeAttribute('open');
      });
      positionDropdown(event.target);
    }, true);

    observeNativeResults(root);
  }

  function initAll() {
    document.querySelectorAll('[data-livish-filter]').forEach(init);
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-livish-filter-dropdown][open]').forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-livish-filter-dropdown][open]').forEach(positionDropdown);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
